// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XHhs","col":"styles_col__2oYM1"};